import { render } from "./medias.vue?vue&type=template&id=0deec3a6"
import script from "./medias.vue?vue&type=script&lang=js"
export * from "./medias.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__